import {createSelector} from 'reselect';

export const errorBranch = state => state.error;

export const authErrors = createSelector(
    errorBranch,
    error => error.auth
);

export const profileErrors = createSelector(
    errorBranch,
    error => error.profile
);



// WEBPACK FOOTER //
// /src/redux/selectors/error.js